import { adminRoutes } from "./adminRoutes";
import { nonAuthRoutes } from "./nonAuthRoutes";

export const routes = [
  ...nonAuthRoutes,
  ...adminRoutes
];
